import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { ListCardGroupVariant } from './types';

export const NUM_COLUMNS = 3;
export const CONTENT_CONTAINER_PADDING_MOBILE = 4;

export const ListCardGroupContainer = Box.withConfig<{ $isFullContainer: boolean }>(
  ({ $isFullContainer }) => ({
    width: 'full',
    paddingX: { base: '$0', md: $isFullContainer ? '$0' : '$64' },
  })
);

export const ListHeader = ({
  listCardGroupVariant,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & {
  listCardGroupVariant: ListCardGroupVariant;
}) =>
  React.createElement(Typography, {
    accessible: true,
    variant: 'headerTwo',
    fontSize: 16,
    my: '$2',
    px: '$2',
    mb: '$0',
    textAlign: listCardGroupVariant === ListCardGroupVariant.SINGLE ? 'center' : undefined,
    ...props,
  });

export const RenderItemRowContainer = Box.withConfig<{
  listCardGroupVariant: ListCardGroupVariant;
}>(({ listCardGroupVariant }) => ({
  flexDirection: 'row',
  justifyContent: listCardGroupVariant === ListCardGroupVariant.SINGLE ? 'center' : 'initial',
}));
